import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useViewerIdentity from '../../hooks/useViewerIdentity';
import { getStoredAuthToken } from '../../utils/authStorage';

const buildRedirectTarget = (location) => {
  const pathname = location?.pathname || '/';
  const search = location?.search || '';
  const hash = location?.hash || '';
  return `${pathname}${search}${hash}`;
};

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const { user } = useViewerIdentity();
  const isAuthenticated = Boolean(user || getStoredAuthToken());

  if (!isAuthenticated) {
    const redirectTarget = buildRedirectTarget(location);
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTarget)}`} replace />;
  }

  return children;
};

export default RequireAuth;
